<script setup>
  import { storeToRefs } from "pinia";
  import { Trash, Plus } from "lucide-vue-next";
  import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
  import { EmptyState } from "@/components/episto-ui/empty-state";
  import { FormItem } from "@/components/ui/form";
  import { Input } from "@/components/ui/input";
  import { Button } from "@/components/ui/button";
  import { Label } from "@/components/ui/label";
  import { Select } from "@/components/episto-ui/select";
  import { useContactsStore } from "@stores/survey/mailing/contacts";
  import { useContactTestAttributesStore } from "@stores/survey/mailing/contactTestAttributes";

  const contactsStore = useContactsStore();
  const contactTestAttributes = useContactTestAttributesStore();
  const { areContactsEmpty, selectedContact } = storeToRefs(contactsStore);
  const {
    areAttributesPresent,
    getContactTestAttributes,
    getContactAttributesNameOptions,
    getContactAttributesValueOptions,
  } = storeToRefs(contactTestAttributes);
  const { addAttribute, removeAttribute, updateContactAttributesName, updateContactAttributesValue } =
    contactTestAttributes;
</script>

<template>
  <Card class="p-6">
    <CardHeader>
      <CardTitle class="heading-page">Edit contact</CardTitle>
    </CardHeader>
    <CardContent v-if="areContactsEmpty">
      <EmptyState
        class="py-0"
        title="No contact yet..." />
    </CardContent>
    <CardContent
      v-else
      class="space-y-6">
      <FormItem>
        <Label for="contact-name">Name</Label>
        <Input
          id="contact-name"
          v-model="selectedContact.name" />
      </FormItem>
      <FormItem>
        <Label>Custom Attributes</Label>
        <div
          v-if="areAttributesPresent"
          class="flex flex-col gap-2">
          <div class="grid grid-cols-[1fr_1fr_auto] gap-4 text-sm font-medium text-muted-foreground">
            <span>Name</span>
            <span>Value</span>
            <span class="w-9" />
          </div>
          <div
            v-for="(item, i) in getContactTestAttributes"
            :key="`attribute-${i}`"
            class="grid grid-cols-[1fr_1fr_auto] items-center gap-4">
            <Select
              :model-value="item.key"
              :options="getContactAttributesNameOptions"
              filterable
              creatable
              placeholder="Select or type..."
              @update:model-value="(val) => updateContactAttributesName(i, val)" />
            <Select
              :model-value="item.value"
              :options="getContactAttributesValueOptions[item.key] || []"
              filterable
              creatable
              placeholder="Select or type..."
              @update:model-value="(val) => updateContactAttributesValue(i, val)" />
            <Button
              variant="ghost"
              size="icon"
              @click="removeAttribute(i)">
              <Trash class="h-4 w-4" />
            </Button>
          </div>
        </div>
        <Button
          class="w-fit mt-2"
          variant="default"
          @click="addAttribute">
          <Plus />
          Add Custom Attribute
        </Button>
      </FormItem>
    </CardContent>
  </Card>
</template>
